
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const ComplianceCalendarTab = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Secretarial Compliance Calendar</CardTitle>
        <CardDescription>
          View upcoming filing deadlines, board meetings, and other secretarial events
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex justify-end space-x-2">
            <Button variant="outline" size="sm">Month</Button>
            <Button variant="outline" size="sm">Week</Button>
            <Button variant="outline" size="sm" className="bg-muted">Day</Button>
          </div>
          
          <div className="border rounded-md p-4">
            <div className="text-center border-b pb-2 mb-4">
              <h3 className="font-medium">May 2025</h3>
            </div>
            
            <div className="space-y-4">
              <div className="flex">
                <div className="w-24 font-medium">May 7</div>
                <div className="flex-1">
                  <div className="bg-blue-100 text-blue-800 p-2 rounded-md">
                    <h4 className="text-sm font-medium">Board Meeting</h4>
                    <p className="text-xs">Q4 Financial Results</p>
                  </div>
                </div>
              </div>

              <div className="flex">
                <div className="w-24 font-medium">May 12</div>
                <div className="flex-1">
                  <div className="bg-red-100 text-red-800 p-2 rounded-md">
                    <h4 className="text-sm font-medium">Filing Deadline</h4>
                    <p className="text-xs">GST Return Filing</p>
                  </div>
                </div>
              </div>

              <div className="flex">
                <div className="w-24 font-medium">May 20</div>
                <div className="flex-1">
                  <div className="bg-green-100 text-green-800 p-2 rounded-md">
                    <h4 className="text-sm font-medium">Annual General Meeting</h4>
                    <p className="text-xs">2025 AGM</p>
                  </div>
                </div>
              </div>

              <div className="flex">
                <div className="w-24 font-medium">May 30</div>
                <div className="flex-1">
                  <div className="bg-yellow-100 text-yellow-800 p-2 rounded-md">
                    <h4 className="text-sm font-medium">Committee Meeting</h4>
                    <p className="text-xs">Audit Committee Review</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default ComplianceCalendarTab;
